import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import "./selectCustom.css";

const SelectCustom = ({
  label = "",
  value = "",
  onChange,
  options = [],
  customClass = "custom-textfield",
  error = false,
  helperText = "",
  placeholder = "",
  height = "53px",
  disabled = false,
}) => {
  return (
    <FormControl
      fullWidth
      variant="outlined"
      className={customClass}
      error={error}
      sx={{ '.MuiOutlinedInput-root': { height: height } }}
    >
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        value={value}
        onChange={onChange}
        displayEmpty={!!placeholder}
        disabled={disabled}
        input={<OutlinedInput label={label || undefined} />}
        renderValue={(selected) => {
          if (!selected)
            return <span className="text-gray-400">{placeholder}</span>;
          const selectedOption = options.find((opt) => opt.value === selected);
          return selectedOption?.label || selected;
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 200,
              width: 200,
            },
          },
        }}
      >
        {placeholder && (
          <MenuItem value="" disabled hidden>
            {placeholder}
          </MenuItem>
        )}
        {options.map((opt) => {
          // Check if the item should be disabled based on fullAddress.is_applicable
          const isItemDisabled = opt.fullAddress && opt.fullAddress.is_applicable === false;

          return (
            <MenuItem
              key={opt.value}
              value={opt.value}
              disabled={isItemDisabled} // This greys out the item and prevents selection
              sx={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                display: "block",
                maxWidth: "100%",
                // Optional: ensure the disabled text is clearly greyed out if default isn't enough
                "&.Mui-disabled": {
                  opacity: 0.6,
                  color: "gray",
                }
              }}
            >
              {opt.label}
            </MenuItem>
          );
        })}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default SelectCustom;
